// Core
import styled from 'styled-components';

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 12px 0 20px;
  gap: 20px;
`;
